import { supabase } from "@/lib/supabase";

export interface SiteSettingRow {
  key: string;
  value: unknown;
  updated_at: string;
}

/** Reads every site_settings row as a key → value map. */
export async function loadSiteSettingRows(): Promise<Record<string, unknown>> {
  const { data, error } = await supabase.from("site_settings").select("*");
  if (error) throw error;
  const map: Record<string, unknown> = {};
  (data as SiteSettingRow[] | null || []).forEach((row) => {
    map[row.key] = row.value;
  });
  return map;
}

/** Upserts a single settings key (brand, nav, footer, home_hero…). */
export async function saveSiteSetting(key: string, value: unknown): Promise<void> {
  const { error } = await supabase
    .from("site_settings")
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: "key" });
  if (error) throw error;
}